/* eslint-disable @typescript-eslint/unbound-method */
import { AbilityBuilder, Ability } from '@casl/ability';

const { build } = new AbilityBuilder(Ability);

export default build();
